import React from 'react';
import { getFullImageUrl, getStatusBadge } from '../utils/helpers';

const DataTable = ({ items, columns, onEdit, onDelete, onToggle }) => {
  if (!items || items.length === 0) {
    return (
      <div style={{ textAlign: 'center', padding: '3rem', background: '#F7F9FC', borderRadius: '12px' }}>
        <i className="fas fa-database" style={{ fontSize: '3rem', color: '#CBD5E1', marginBottom: '1rem' }} />
        <p style={{ color: '#5A6E7F' }}>No data found. Click "Add New" to create one.</p>
      </div>
    );
  }

  const getValue = (item, column) => {
    // Handle Image/Logo/Photo/Avatar columns
    if (column === 'Image' || column === 'Logo' || column === 'Photo' || column === 'Avatar') {
      const imgUrl = item.imageUrl || item.logo || item.photo || item.avatar;
      return imgUrl ? <img src={getFullImageUrl(imgUrl)} alt="" style={{ width: '40px', height: '40px', objectFit: 'cover', borderRadius: '8px' }} /> : '-';
    }
    
    // Handle Status column
    if (column === 'Status') {
      const isActive = item.isActive !== false;
      const status = getStatusBadge(isActive);
      return (
        <button 
          onClick={() => onToggle?.(item._id || item.id, isActive)} 
          style={{ padding: '0.25rem 0.75rem', borderRadius: '20px', border: 'none', background: status.bg, color: status.color, cursor: 'pointer' }}
        >
          {status.text}
        </button>
      );
    }
    
    // Handle Actions column
    if (column === 'Actions') {
      return (
        <div style={{ display: 'flex', gap: '0.5rem' }}>
          <button 
            onClick={() => onEdit(item)} 
            style={{ padding: '0.25rem 0.75rem', background: '#2C7A7B', color: 'white', border: 'none', borderRadius: '4px', cursor: 'pointer' }}
          >
            <i className="fas fa-edit" /> Edit
          </button>
          <button 
            onClick={() => onDelete(item._id || item.id)} 
            style={{ padding: '0.25rem 0.75rem', background: '#DC2626', color: 'white', border: 'none', borderRadius: '4px', cursor: 'pointer' }}
          >
            <i className="fas fa-trash" /> Delete
          </button>
        </div>
      );
    }
    
    // Handle Order column
    if (column === 'Order') return item.order || 0;
    
    // Handle Date column
    if (column === 'Date' && item.startDate) return new Date(item.startDate).toLocaleDateString();
    
    // Handle Rating column
    if (column === 'Rating') return '⭐'.repeat(item.rating || 5);
    
    // Handle Icon column (for menus)
    if (column === 'Icon') return <span style={{ fontSize: '1.5rem' }}>{item.icon || '📄'}</span>;
    
    // Handle Path column (for menus)
    if (column === 'Path') return <code style={{ background: '#F7F9FC', padding: '0.25rem 0.5rem', borderRadius: '4px' }}>{item.path}</code>;
    
    // Default: get value by key
    const key = column.toLowerCase().replace(/ /g, '');
    const value = item[key] || item[column.toLowerCase()] || '-';
    
    // Truncate long text
    if (typeof value === 'string' && value.length > 50) {
      return value.substring(0, 50) + '...';
    }
    
    return value;
  };

  return (
    <div style={{ overflowX: 'auto' }}>
      <table style={{ width: '100%', background: 'white', borderRadius: '12px', overflow: 'hidden', boxShadow: '0 1px 3px rgba(0,0,0,0.1)' }}>
        <thead style={{ background: '#F7F9FC' }}>
          <tr>
            {columns.map((col, idx) => (
              <th key={idx} style={{ padding: '1rem', textAlign: 'left', fontWeight: 600, color: '#0A192F' }}>{col}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {items.map((item, idx) => (
            <tr key={item._id || item.id || idx} style={{ borderBottom: '1px solid #E2E8F0', transition: 'background 0.2s' }} onMouseEnter={(e) => e.currentTarget.style.background = '#F9FAFB'} onMouseLeave={(e) => e.currentTarget.style.background = 'white'}>
              {columns.map((col, colIdx) => (
                <td key={colIdx} style={{ padding: '1rem', verticalAlign: 'middle' }}>{getValue(item, col)}</td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default DataTable;